module.exports = __webpack_public_path__ + "static/SA_AssistApp_Graphic-798d1ba179ca7b58ac84669ab7db3eaa.png";